
//import { Injectable } from '@angular/core';

import moment from 'moment';
import { CalendarTemplateDay } from 'src/app/models/CalendarTemplate';
import { StartEndTime, StartEndDateRange } from './models';


//@Injectable()
export class CalDatesService {

  constructor() { }

  todayDateOnly(): Date {
    return this.dateOnly( moment(new Date()).toDate());
    //let d = new Date();
    //return this.dateOnly(d);
  }

  /*
  tomorrowDateOnly(): Date {
    return this.nextDay(this.dateOnly(new Date()));
    //let d = new Date();
    //return this.dateOnly(d);
  }
  */
  
  dateOnly(datetime: Date): Date {
    let d = moment(datetime).toDate();
    d.setHours(0, 0, 0, 0);
    return d;
  }

  setTimeValue(datetime: Date, timeDate: Date): Date {
    let d = moment(datetime).toDate();
    d.setHours(timeDate.getHours(), timeDate.getMinutes(), timeDate.getSeconds(), timeDate.getMilliseconds());
    return d;
  }

  nextDay(datetime: Date): Date {
    let d = moment(datetime).toDate();
    d.setDate(datetime.getDate() + 1);
    return d;

  }

  firstDayOfMonth(datetime: Date): Date {
    let d = moment(datetime).toDate();
    d.setDate(1);
    return d;
  }
 
  weekdayStringToNum(weekday: string): number {
    switch (weekday.toLowerCase()) {
      case 'monday':
        return 1;
      case 'tuesday':
        return 2;
      case 'wednesday':
        return 3;
      case 'thursday':
        return 4;
      case 'friday':
        return 5;
      case 'saturday':
        return 6;
      default:
        return 0;
    }
  }

  dateAsString(timeComponent: string, dateComponent: any): string {
    let dtTimeComponent = moment(timeComponent).toDate();
    let dtDateComponent = moment(dateComponent).toDate();
    let s: string = dtDateComponent.getFullYear().toString() + '-';
    s = s + this.padZero(dtDateComponent.getMonth() + 1) + '-';
    s = s + this.padZero(dtDateComponent.getDate()) + 'T';
    s = s + this.padZero(dtTimeComponent.getHours()) + ':';
    s = s + this.padZero(dtTimeComponent.getMinutes()) + ':' + this.padZero(dtTimeComponent.getSeconds());
    return s;
//    day.startTime = this.datePipe.transform(d, 'yyyy-MM-ddTHH:mm:ss', 'UTC');

  }
  
/**
 * @param dateComponent a valid date - if it has a time component it will be ignored
 * @returns a string formatted like '2000-07-27'
**/
  dateOnlyAsString(dateComponent: Date): string {
    if(dateComponent==null || dateComponent.toString()=='')
    dateComponent=moment(dateComponent).toDate();
    let s: string = dateComponent.getFullYear().toString() + '-';
    s = s + this.padZero(dateComponent.getMonth() + 1) + '-';
    s = s + this.padZero(dateComponent.getDate());
    return s;
  }

/**
 * returns a string formatted like '2000-07-27T13:00:00'
**/
  dateTimeAsString(dateTimeComponent: any): string {
    let s: string = dateTimeComponent.getFullYear().toString() + '-';
    s = s + this.padZero(dateTimeComponent.getMonth() + 1) + '-';
    s = s + this.padZero(dateTimeComponent.getDate()) + 'T';
    s = s + this.padZero(dateTimeComponent.getHours()) + ':';
    s = s + this.padZero(dateTimeComponent.getMinutes()) + ':' + this.padZero(dateTimeComponent.getSeconds());
    return s;
//    day.startTime = this.datePipe.transform(d, 'yyyy-MM-ddTHH:mm:ss', 'UTC');

  }

/**
 * @param dateComponent a valid date string that can be passed into Date() constructor - if it has a time component it will be ignored
 * @param timeComponent should be formatted like '13:00:00'
 * @returns a string formatted like '2000-07-27T13:00:00'
**/
  buildDateTimeString(dateComponent: string, timeComponent: string): string {
    let d = moment(dateComponent).toDate();
    let s: string = d.getFullYear().toString() + '-';
    s = s + this.padZero(d.getMonth() + 1) + '-';
    s = s + this.padZero(d.getDate()) + 'T';
    s = s + timeComponent;
    return s;
  }


  getAllTemplateDates(weekday: string, /* startDate: Date, */ templateStart: Date, templateEnd: Date): Date[] {
    let dlist: Date[] = [];
    const monthStart = this.firstDayOfMonth(templateStart); //startDate); 
    const weekdayNum: number = this.weekdayStringToNum(weekday);
if(templateEnd==null || templateEnd.toString()=='')
templateEnd=moment(moment(new Date(moment(new Date()).toDate().getUTCDate())).toDate().setFullYear(moment(new Date(moment(new Date()).toDate().getUTCDate())).toDate().getFullYear() + 1)).toDate();
    if (templateEnd < monthStart)
      return dlist;

    let d = moment(monthStart).toDate();
    let firstDate: Date;

    //find first instance of the weekday
    for (let i = 1; i <= 7; i++) {
      if (d.getDay() === weekdayNum) {
        firstDate = moment(d).toDate();
        break;
      }
      d.setDate(monthStart.getDate() + i);
    }

    //get list of all instances of this weekday up until the end of the template
    if (templateStart <= firstDate && templateEnd >= firstDate)
      dlist.push(firstDate);
    let j: number = 7;
    d = moment(firstDate).toDate();
    while (true) {
      d.setDate(d.getDate() + 7);
      if (d > templateEnd)
        break;
      if (templateStart <= d)
        dlist.push(moment(d).toDate());
      j = j + 7;
    }

    return dlist;
  }

/**
 * @param startDateTime a valid date and time for the start of an appointment
 * @param endDateTime a valid date and time for the end of an appointment
 * @returns number of minutes between the two times
**/
  public calculateDuration(startDateTime: Date, endDateTime: Date): number {
    const diff = Math.abs(endDateTime.getTime() - startDateTime.getTime());
    return Math.floor((diff / 1000) / 60);    
  }

  private padZero(value: number): string {
    return ((value < 10 ? '0' : '').concat(value.toString()));
  }

/**
 * @param dateTimeString a valid date string that can be passed into Date() constructor - if it has a date component it will be ignored
 * @returns a string formatted like '13:00:00'
**/
public extractTimeFromDateTimeString(dateTimeString: string): string {
    let dtTimeComponent = moment(dateTimeString).toDate();
    return this.padZero(dtTimeComponent.getHours()) + ':' + 
        this.padZero(dtTimeComponent.getMinutes()) + ':' + this.padZero(dtTimeComponent.getSeconds());
  }

  public extractStartEndTimes(ctDays: CalendarTemplateDay[]): StartEndTime[] {
    let retVal: StartEndTime[] = [];
    if (ctDays) {
      for (let j = 0; j < ctDays.length; j++) {
        //let dtTimeComponent = new Date(ctDays[j].startTime);
        //let startString: string = this.padZero(dtTimeComponent.getHours()) + ':' + 
        //    this.padZero(dtTimeComponent.getMinutes()) + ':' + this.padZero(dtTimeComponent.getSeconds());
        //dtTimeComponent = new Date(ctDays[j].endTime);
        //let endString: string = this.padZero(dtTimeComponent.getHours()) + ':' + 
        //   this.padZero(dtTimeComponent.getMinutes()) + ':' + this.padZero(dtTimeComponent.getSeconds());


        let startString: string = this.extractTimeFromDateTimeString(ctDays[j].startTime);
        let endString: string = this.extractTimeFromDateTimeString(ctDays[j].endTime);
        if (!retVal.find(e => e.startTime == startString && e.endTime == endString)) {
          retVal.push({ 
            startTime: startString, 
            endTime: endString, 
            visitTypeId: ctDays[j].visitTypeId,
            bookinglimit: ctDays[j].bookinglimit
          });
        }
      }
    }
    return retVal;
  }

 /* 
  public extractStartEndTime(ctDay: CalendarTemplateDay): StartEndTime {
    let retVal: StartEndTime;
    if (ctDay) {
      retVal = { startTime: this.extractTimeFromDateTimeString(ctDay.startTime), 
          endTime: this.extractTimeFromDateTimeString(ctDay.endTime) };
    }
    return retVal;
  }
*/

  public extractStartEndDateRanges(ctDays: CalendarTemplateDay[]): StartEndDateRange[] {
    let retVal: StartEndDateRange[] = [];
    if (ctDays) {
      for (let j = 0; j < ctDays.length; j++) {
        // if dayofweek is blank, then no dates have been assigned to this template yet
        if (ctDays[j].dayofweek) {
          let startDate = this.dateOnly(moment(ctDays[j].startTime).toDate());
          let endDate = this.dateOnly(moment(ctDays[j].endTime).toDate());
          if (!retVal.find(e => e.startDate == startDate && e.endDate == endDate && 
              e.dayOfWeek.toLowerCase() == ctDays[j].dayofweek.toLowerCase())) {
            retVal.push({ startDate: startDate, endDate: endDate, dayOfWeek: ctDays[j].dayofweek });
          }
        }
      }
    }
    return retVal;
  }

}
